/* eslint-disable */
import { useMemo, useState, useEffect, useRef, React } from "react";
import GolferApi from "../../services/golfer-api";
import { Centrifuge } from "centrifuge";
import JoinChallengeInfoModal from "../../shared/components/modals/JoinChallengeInfoModal";
import { Star, StarOutline } from "@mui/icons-material";
import { store } from "../../shared/store";
import { showToast } from "../../shared/helpers/show-toast";
import ChallengeLeaderboardFilter from "./ChallengeLeaderboardFilter/FilterDropdown";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import Navigate from "../../shared/navigation/navigate";
import { formatDateRange } from "./utils";

export default function Leaderboard() {
  const [currentUser, setCurrentUser] = useState(false);
  const [localStorageToken, setLocalStorageToken] = useState(null);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [userRanking, setUserRanking] = useState("");
  const [roundsPosted, setRoundsPosted] = useState("");
  const [challengeInfo, setChallengeInfo] = useState(null);
  const [topScores, setTopScores] = useState([]);
  const [totalScore, setTotalScore] = useState("");
  const centrifugeRef = useRef(null);
  const subRef = useRef(null);
  const pageRef = useRef(1);
  const [userName, setUserName] = useState(null);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20); // Load 20 rows initially
  const [preview, setPreview] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);
  const [selectedStatus, setSelectedStatus] = useState("all"); // Stores single selected status
  const [isFollowingChecked, setIsFollowingChecked] = useState(false); // Following checkbox state
  const [selectedFilters, setSelectedFilters] = useState([]); // Array to hold applied filters
  const handleResize = () => setIsSmallScreen(window.innerWidth < 600);
  const computed_name =
    currentUser && isSmallScreen
      ? "GOLFER (H.I.)"
      : !currentUser
      ? "GOLFER"
      : "GOLFER (HANDICAP INDEX)";

  const getPrivateToken = async (pageNo) => {
    const path = window.location.pathname;
    const pathParts = path.split("/");
    const idFromUrl = pathParts[pathParts.length - 1];
    const response = await GolferApi.getPrivateLeaderboardToken(
      pageNo,
      idFromUrl
    );
    console.log(response.data.token);
    return response.data.token;
  };

  const getToken = async () => {
    const response = await GolferApi.getLeaderboardToken();
    return response.data.token;
  };

  useEffect(() => {
    const token = localStorage.getItem("ghin-user-token");
    setLocalStorageToken(token);
  }, []);

  const ws_connection = (pageNo = 0) => {
    const path = window.location.pathname;
    const pathParts = path.split("/");
    const idFromUrl = pathParts[pathParts.length - 1];

    const init = async () => {
      centrifugeRef.current = new Centrifuge(
        process.env.REACT_APP_CENTRIFUGO_URL,
        {
          getToken: getToken,
        }
      );
      centrifugeRef.current.connect();
    };
    init();
    centrifugeRef.current
      .on("connecting", function (ctx) {
        console.log(`connecting: ${ctx.code}, ${ctx.reason}`);
      })
      .on("connected", function (ctx) {
        console.log(`connected over ${ctx.transport}`);
      })
      .on("disconnected", function (ctx) {
        console.log(`disconnected: ${ctx.code}, ${ctx.reason}`);
      })
      .on("unsubscribed", function (ctx) {
        console.log("unsubscribed from server-side channel", ctx.channel);
      })
      .connect();
    if (userName) {
      subRef.current = centrifugeRef.current.newSubscription(
        "$leaderboard:" + idFromUrl + ":private",
        { getToken: () => getPrivateToken(pageNo) }
      );
      centrifugeRef.current
        .presence("$leaderboard:" + idFromUrl + ":private")
        .then(
          function (resp) {
            console.log(resp);
          },
          function (err) {
            console.log("presence error", err);
          }
        );
    } else {
      subRef.current = centrifugeRef.current.newSubscription(
        "leaderboard:" + idFromUrl + ":public"
      );
      centrifugeRef.current
        .presence("leaderboard:" + idFromUrl + ":public")
        .then(
          function (resp) {
            console.log(resp);
          },
          function (err) {
            console.log("presence error", err);
          }
        );
    }
    subRef.current
      .on("publication", function (ctx) {
        getData(true);
      })
      .on("subscribing", function (ctx) {
        console.log(`subscribing: ${ctx.code}, ${ctx.reason}`);
      })
      .on("subscribed", function (ctx) {
        console.log("subscribed", ctx);
      })
      .on("unsubscribed", function (ctx) {
        console.log(`unsubscribed: ${ctx.code}, ${ctx.reason}`);
      })
      .subscribe();
  };

  const closeModal = () => {
    setInfoModalOpen(false);
  };

  useEffect(() => {
    // ws_connection(0);
    // return () => {
    // if (centrifuge.current) {
    // centrifuge.disconnect();
    // }
    // };
  }, []);

  useEffect(() => {
    // check params
    const params = new URLSearchParams(window.location.search);
    if (params.has("per_page")) {
      setPerPage(params.get("per_page"));
    }

    if (params.has("preview")) {
      setPreview(params.get("preview"));
    }

    getData();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [selectedStatus, selectedFilters, page, perPage]);

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
    updateSelectedFilters("Status", value);
  };

  const handleFollowingChange = () => {
    const newValue = !isFollowingChecked;
    setIsFollowingChecked(newValue);
    updateSelectedFilters("Following", newValue ? "Following" : "");
  };

  const updateSelectedFilters = (type, value) => {
    setSelectedFilters((prevFilters) => {
      const updatedFilters = prevFilters.filter(
        (filter) => filter.type !== type
      );
      if (value) {
        updatedFilters.push({ type, value });
      }
      return updatedFilters;
    });
  };

  const getData = (all = false) => {
    let status =
      selectedStatus === "All Golfers"
        ? "all"
        : selectedStatus === "In-Progress"
        ? "in_progress"
        : selectedStatus.toLowerCase();
    let params;
    if (all) params = { page: 1, per_page: perPage * pageRef.current, status };
    else params = { page, per_page: perPage, status };

    if (isFollowingChecked) params["following"] = true;

    const path = window.location.pathname;
    const pathParts = path.split("/");
    const idFromUrl = pathParts[pathParts.length - 1];
    let id = idFromUrl;

    const ghin_number =
      store.getState().authReducer.loginReducer.user.ghin_number;

    GolferApi.getGolferChallengeData(ghin_number)
      .then((res) => {
        if (res.data[0] && res.data[0].id == id) {
          setTopScores(res.data[0].top_3_scores);
          setRoundsPosted(res.data[0].scores.length);
          setTotalScore(res.data[0].total_net_score_to_par);
          setUserRanking(res.data[0].ranking);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    GolferApi.getChallengeData(id)
      .then((res) => {
        setChallengeInfo(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    GolferApi.getData(id, params)
      .then((res) => {
        if (res.data.mode) {
          setCurrentUser(res.data.current_user);
          setUserName(res.data.username);
        }

        let leaderboardData = [];
        if (all || page === 1) leaderboardData = res.data.leaderboard;
        else {
          leaderboardData = data.concat(res.data.leaderboard);

          let duplicatePositionIndex = -1;
          if (res.data.leaderboard[0]?.ghin_number === res.data.current_user)
            duplicatePositionIndex = leaderboardData.findLastIndex(
              (e) => e.ghin_number === res.data.current_user
            );
          else
            duplicatePositionIndex = leaderboardData.findIndex(
              (e) => e.ghin_number === res.data.current_user
            );

          // Removes duplicate position of the curent user
          leaderboardData.splice(duplicatePositionIndex, 1);
        }

        setData(leaderboardData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLoadMore = () => {
    // centrifugeRef.current.removeSubscription(subRef.current);
    // ws_connection(page + 1);
    pageRef.current += 1;
    setPage(page + 1);
  };

  const columns = useMemo(() => {
    const round_size = isSmallScreen ? 35 : 70;
    const position_size = isSmallScreen ? 35 : 90;
    const baseColumns = [
      {
        accessorKey: "position",
        header: isSmallScreen ? "POS" : "POSITION",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        grow: false,
        size: position_size,
        Cell: ({ row }) => (
          <div className="row">
            <span className="position-cell">
              <div className="col is-1-of-2">
                {row.original.position_display}
              </div>
              {currentUser && !isSmallScreen && (
                <div className="col is-2-of-2">
                  {row.original.followed === true ? (
                    <Star className="icon-star" />
                  ) : (
                    <StarOutline className="icon-star-outline" />
                  )}
                </div>
              )}
            </span>
          </div>
        ),
        muiTableHeadCellProps: { className: "header-position" },
        muiTableBodyCellProps: { className: "body-position" },
      },
      {
        accessorKey: "name",
        header: computed_name,
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: 120,
        Cell: ({ row }) => (
          <span className="name-cell">
            <span className="name-display">
              {row.original.short_name && isSmallScreen
                ? row.original.short_name
                : row.original.name}
            </span>
            {currentUser && (
              <span className="handicap-display">
                {row.original.hi_display}
              </span>
            )}
          </span>
        ),
        muiTableHeadCellProps: { className: "header-name" },
        muiTableBodyCellProps: { className: "body-name" },
      },
      {
        accessorKey: "total",
        header: isSmallScreen ? "Total" : "TOTAL",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span
            className={
              row.original.total?.includes("-")
                ? "total-negative"
                : "total-positive"
            }
          >
            {row.original.total}
          </span>
        ),
        muiTableHeadCellProps: {
          className: "header-total",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
            },
          },
        },
        muiTableBodyCellProps: {
          className: "body-total",
          sx: {
            backgroundColor: !currentUser ? "rgba(0,0,0,0.07)" : "inherit",
          },
        },
      },
      {
        accessorKey: "r1",
        header: isSmallScreen ? "R1" : "RD1",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span className="round-cell">{row.original.r1}</span>
        ),
        muiTableHeadCellProps: {
          className: "header-round",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-round" },
      },
      {
        accessorKey: "r2",
        header: isSmallScreen ? "R2" : "RD2",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span className="round-cell">{row.original.r2}</span>
        ),
        muiTableHeadCellProps: {
          className: "header-round",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-round" },
      },
      {
        accessorKey: "r3",
        header: isSmallScreen ? "R3" : "RD3",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span className="round-cell">{row.original.r3}</span>
        ),
        muiTableHeadCellProps: {
          className: "header-round",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-round" },
      },
    ];
    return baseColumns;
  }, [isSmallScreen, currentUser, computed_name]);

  const table = useMaterialReactTable({
    columns,
    data,
    layoutMode: "grid",
    defaultColumn: { minSize: 35 },
    enablePagination: false,
    enableBottomToolbar: false,
    enableRowPinning: true,
    enableRowSelection: false,
    enableStickyHeader: true,
    rowPinningDisplayMode: "select-sticky",
    getRowId: (row) => row.name,
    initialState: {
      density: "compact",
      expanded: true,
      rowPinning: {
        top: data.some((row) => row.name === userName) ? [userName] : [],
      },
    },
    enableColumnFilterModes: false,
    enableGlobalFilter: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        height: isSmallScreen ? "43px" : "77px",
        backgroundColor:
          row.id === userName ? `#00365F0D !important` : undefined,
      },
    }),
    muiTableContainerProps: {
      sx: {
        minHeight: "100vh",
        "@media (max-width: 600px)": {
          maxWidth: "100%",
          overflowX: "auto",
          fontSize: "6px",
        },
        "@media (min-width: 601px)": {
          maxWidth: "100%",
          fontSize: "10px",
        },
      },
    },
    muiTablePaperProps: {
      sx: {
        elevation: 0, // Remove shadow by setting elevation to 0
        border: "none", // Ensure border is removed
        boxShadow: "none !important", // Explicitly remove box shadow
      },
    },
  });
  return (
    <div className="challenge-page-container">
      <div className="challenges-page-header">Challenges</div>
      {!preview && (
        <div className="challenge-content">
          {challengeInfo && (
            <div className="leaderboard-header-container">
              <div className="leaderboard-info-box leaderboard-three-columns">
                <div className="leaderboard-column1">
                  <h3
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      marginTop: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    {!userRanking || userRanking === "-"
                      ? `${challengeInfo ? challengeInfo.name : ""} has ended`
                      : userRanking === "1st"
                      ? `You won the ${
                          challengeInfo ? challengeInfo.name : ""
                        }!`
                      : `You completed the ${
                          challengeInfo ? challengeInfo.name : ""
                        }!`}{" "}
                  </h3>

                  <div style={{ margin: 0, color: "#475467" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "10px",
                      }}
                    >
                      <div className="usga-calendar-small" />
                      <span>
                        {!challengeInfo
                          ? ""
                          : formatDateRange(
                              challengeInfo?.start_date,
                              challengeInfo?.end_date
                            )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "10px",
                      }}
                    >
                      <div className="people-small" />
                      <span>
                        {!challengeInfo
                          ? ""
                          : `${challengeInfo.golfers} golfers`}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "10px",
                      }}
                    >
                      <div className="golfcup-small" />
                      <span>3+ rounds to qualify</span>
                    </div>
                  </div>
                </div>

                <div className="leaderboard-column2">
                  <div className="leaderboard-circle-text-above">
                    FINAL RANKING
                  </div>

                  <div
                    className="outer-circle-lighter"
                    style={{
                      width: "80px",
                      height: "80px",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "50%",
                        backgroundColor: "#00365F",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#FFF",
                      }}
                    >
                      <span style={{ fontSize: "24px", fontWeight: "bold" }}>
                        {userRanking || "-"}
                      </span>
                      <span style={{ fontSize: "15px" }}>
                        {"of " + (challengeInfo?.golfers || "-")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="leaderboard-column3">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr  1fr 1fr",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "700",
                      marginBottom: "20px",
                      alignItems: "center",
                      color: "#465476",
                    }}
                  >
                    <div>
                      <div>ROUNDS POSTED</div>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "24px",
                          fontWeight: "700",
                          color: "#000",
                        }}
                      >
                        {roundsPosted || "-"}
                      </div>
                    </div>
                    <div>
                      <div>BEST NET SCORE</div>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "24px",
                          fontWeight: "700",
                          color: "#000",
                        }}
                      >
                        {topScores[0]?.net_to_par || "-"}
                      </div>
                    </div>
                    <div>
                      <div>TOTAL NET SCORE</div>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "24px",
                          fontWeight: "700",
                          color: "#000",
                        }}
                      >
                        {totalScore || "-"}
                      </div>
                    </div>
                  </div>

                  <div
                    className="join-button-container"
                    style={{ marginTop: "10px" }}
                  >
                    <div className="share-row">
                      <div className="usga-share" />
                      <div
                        style={{
                          fontSize: "16px",
                          marginLeft: "5px",
                          fontWeight: "600",
                          cursor: "pointer",
                          color: "#00365F",
                        }}
                        onClick={() => {
                          navigator.clipboard.writeText(
                            window.location.origin +
                              `/leaderboard/${challengeInfo?.id}`
                          );
                          showToast("Leaderboard link copied to clipboard!");
                        }}
                      >
                        SHARE
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Leaderboard Section */}
          <div className="leaderboard-container">
            {/* Leaderboard Table */}
            <div className="white-rectangle">
              <div className="leaderboard-header">
                <div className="challenge-leaderboard-title">Leaderboard</div>
                {currentUser && (
                  <ChallengeLeaderboardFilter
                    isFollowingChecked={isFollowingChecked}
                    handleFollowingChange={handleFollowingChange}
                    selectedStatus={selectedStatus}
                    handleStatusChange={(value) => handleStatusChange(value)}
                  />
                )}
              </div>

              <MaterialReactTable table={table} />

              <div className="challenge-bottom-buttons">
                <button
                  className="btn outline blue"
                  style={{
                    borderRadius: "20px",
                  }}
                  onClick={() => {
                    Navigate.toPath(
                      `/leaderboard-details/${challengeInfo?.id}`
                    );
                  }}
                >
                  VIEW FULL LEADERBOARD
                </button>
              </div>
            </div>
          </div>
          <JoinChallengeInfoModal
            isOpen={infoModalOpen}
            closeModal={closeModal}
          />
        </div>
      )}
    </div>
  );
}
